import React, { useEffect, useState } from "react";


export default function WatchLogo() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    // 100ms interval creates a smooth mechanical ticking motion
    const timer = setInterval(() => {
      setTime(new Date());
    }, 100);

    return () => clearInterval(timer);
  }, []);

  const milliseconds = time.getMilliseconds();
  const seconds = time.getSeconds() + milliseconds / 1000;
  const minutes = time.getMinutes() + seconds / 60;
  const hours = (time.getHours() % 12) + minutes / 60;

  // Hand rotation angles
  const secondAngle = seconds * 6;
  const minuteAngle = minutes * 6;
  const hourAngle = hours * 30;

  return (
    <div className="watch-logo-wrapper">
      <img
        src="/images/login.png"
        alt="Watches Pool Logo"
        className="watch-logo-bg"
      />

      {/* Pocket Watch Hands Overlay */}
      <div className="pocket-watch-dial">
        {/* Hour Hand */}
        <div
          className="hand hour-hand"
          style={{ transform: `rotate(${hourAngle}deg)` }}
        />

        {/* Minute Hand */}
        <div
          className="hand minute-hand"
          style={{ transform: `rotate(${minuteAngle}deg)` }}
        />

        {/* Second Hand */}
        <div
          className="hand second-hand"
          style={{ transform: `rotate(${secondAngle}deg)` }}
        />

        {/* Center Pivot Pin */}
        <div className="center-cap" />
      </div>
    </div>
  );
}